import React from 'react'

function Loader() {
  return (
    <div className='fixed top-0 left-0 right-0 bottom-0 bg-[#020212] z-40'>
    </div>
  )
}

export default Loader